import React from 'react'

export type UserStatus =
  | { state: UserState.Loading }
  | {
    state: UserState.SignedOut;
    signIn: () => void;
  }
  | User;

export enum UserState {
  Loading,
  SignedOut,
  SignedIn,
}

export enum SiteUserRole {
  Admin = 'Admin',
  LimitedAccess = 'LimitedAccess'
}

export interface User {
  state: UserState.SignedIn;
  id: string;
  email: string;
  hasAcceptedCurrentUserAgreement: boolean;
  userAgreementUrl: string;
  userSites: UserSite[];
  selectedSite: UserSite | null;
  setSelectedSite: (site: UserSite | null) => void;
  fetchHeaders: () => Promise<Headers>;
  signOut: (postLogoutUrl?: string) => void;
  refreshUser: () => void;
}

export interface UserSite {
  id: string;
  city: string;
  state: string;
  role: SiteUserRole;
  enablePurchaseOrders: boolean;
}

export const UserContext = React.createContext<UserStatus>({ state: UserState.Loading });
